<template>
  <loading
    :active.sync="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    background-color="#000"
    color="secondary"
    width.number="180"
    height.number="180"
  />
</template>
<script>
// import userAPIs from '../User/userAPIs'
import xeroAPIs from './XeroAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'XeroCallBackAuth',
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false
    };
  },
  mounted() {
    try {
      this.isLoading = true;
      // Get code returned by Instagram
      const authCode = this.$route.query.code;
      if (!authCode) {
        // Redirect to main page
        this.$router.push({ name: 'Home' });
      } else {
        xeroAPIs.handleCallback({ code: authCode }).then(success => {
          this.$swal({
            type: 'success',
            text: 'Connected to Xero'
          }).then(() => {
            this.$router.push({ name: 'Home' });
          });
        });
      }
    } catch (error) {
    } finally {
      this.isLoading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// XeroCallBackAuth.vue?217d68ac